import { Injectable } from '@angular/core';
import { CoreService } from '../../../core/core.service';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class TaxService {

constructor(private coreService: CoreService) { }




SaveTaxCreditData(tcData: any) {
return this.coreService.post('Forms/saveTaxCredit', tcData);
}
// saveRatebookData(postdata) {
//     return this.coreService.post('Ratebook/SaveTaxTables/', postdata);
//   }
}

